import { FC, ReactElement } from "react";
import { Box } from "@mui/material";

import { app_logo, app_logo_full } from "@/constants";
import { useThemeBreakPoints } from "@/hooks";

interface ILogo {
  size?: number;
  full?: boolean;
}

const Logo: FC<ILogo> = ({ size, full }): ReactElement => {
  const { isMatched: IsMdUp } = useThemeBreakPoints({
    action: "up",
    breakpoint: "md",
  });
  
  return (
    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
      {full && IsMdUp ? (
        <img 
          src={app_logo_full} 
          style={{ 
            width: size ? `${size}px` : "98px",
            height: 'auto',
            display: 'block'
          }} 
          alt="Riffs Logo" 
        />
      ) : (
        <img 
          src={app_logo} 
          style={{ 
            width: size ? `${size}px` : "23px",
            height: 'auto',
            display: 'block'
          }} 
          alt="Riffs Logo" 
        />
      )}
    </Box>
  );
};

export default Logo;
